export const ZILLOW_PROFILE_URL = "https://www.zillow.com/profile/Sobeida%20Scherif";
export const ZILLOW_REVIEW_URL = "https://www.zillow.com/reviews/write/?s=X1-ZUtbnl7n3xlafd_3e7gs";
export const GOOGLE_PROFILE_URL = "https://maps.google.com/?cid=3715564280465972471";
export const INSTAGRAM_URL = "https://www.instagram.com/soldbysoby/";

export const REVIEWS = [
  {
    name: "F. Marne",
    date: "January 2026",
    context: "Bought a single-family home in Landover, MD",
    text: "Sobeida is everything you would want in a realtor — attentive, patient, thoughtful, and efficient. We were in a time-sensitive situation and Sobeida went above and beyond to make sure that everything went as quickly as possible without compromising on the things that mattered.",
  },
  {
    name: "Dominique Santos",
    date: "April 2025",
    context: "Bought a single-family home in Landover, MD",
    text: "Sobeida was easy to communicate with from the start, direct and honest when speaking of neighborhoods so that we found the perfect spot for our family. She has so much knowledge of the areas, schools, activities and more.",
  },
  {
    name: "J. Siggs",
    date: "June 2024",
    context: "Bought a townhouse in Petworth, Washington, DC",
    text: "I worked with Sobeida to find my first home and she was great every step of the process. She was always responsive when we had questions or wanted to schedule tours, and worked to help us negotiate with the seller for our home. She has great knowledge of DC area real estate.",
  },
  {
    name: "Verified Zillow Reviewer",
    date: "June 2024",
    context: "Bought a townhouse in Chantilly, VA",
    text: "Sobeida has been my go-to real estate agent. I have worked on three properties with her and all have been great experiences overall, from start to end. She would do her best to get the property you are looking for.",
  },
  {
    name: "Verified Zillow Reviewer",
    date: "July 2023",
    context: "Bought a home in Germantown, MD",
    text: "Sobeida has been my go-to realtor. She has worked with me on a couple of projects and helped me close them successfully, on time. She has good knowledge of the area and kept me up to date on the market listings.",
  },
  {
    name: "Sneha Kheria",
    date: "January 2023",
    context: "First-time home buyer",
    text: "It was great! She is extremely responsive and great at negotiating. During our time purchasing our first home, she never overwhelmed us and helped us negotiate terms we were comfortable with.",
  },
  {
    name: "R. Voetsch",
    date: "August 2022",
    context: "Bought a condo in Bethesda, MD",
    text: "Very personable, professional, and effective in negotiating a reduced price. Sobeida was able to secure a reduced price in one day of negotiations, and we were able to close a few days later.",
  },
  {
    name: "Sanra Ramirez",
    date: "April 2022",
    context: "Bought a single-family home in Twinbrook, Rockville, MD",
    text: "I had a very good experience with Sobeida! She was very helpful in my search, took my requests into consideration, and ensured I was getting the best home. She is very professional and dedicated to her job.",
  },
  {
    name: "Steven Young",
    date: "February 2021",
    context: "Bought a home in Frederick County, MD",
    text: "Sobeida is the greatest! Very knowledgeable, punctual, and professional. She went over and beyond to make my dream home come true.",
  },
];
